import React from 'react'

const RejuvenationDetailSection = ({language,title,text,image}) => {
  return (
      <div className="device-section" dir={language === "ar" ? "rtl" : "ltr"}>
        <div className="device-text">
          <h2>{title}</h2>
          <p>{text}</p>
        </div>
        <div className="device-image">
          <img
            src={image}
            alt="Beauty Devices"
          />
        </div>
      </div>
  )
}

export default RejuvenationDetailSection